import { render } from "./AddEditElevator.vue?vue&type=template&id=217495b2"
import script from "./AddEditElevator.vue?vue&type=script&lang=js"
export * from "./AddEditElevator.vue?vue&type=script&lang=js"

import "./AddEditElevator.vue?vue&type=style&index=0&id=217495b2&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__